// extracted by mini-css-extract-plugin
export default {"wrapper":"button-pads_wrapper__du7Zf"};